import { useTranslation } from 'react-i18next';

import { Description, Label } from 'horizon/components/Damages/DamageStyles.style';

import { ExternalReferenceContainer, ExternalReferenceTitle } from './ExternalReference.style';
import { type ExternalReferenceObservation, useExternalReferenceRows } from './utils';

type Props = {
  observation: ExternalReferenceObservation | null | undefined;
};

export const ExternalReference = ({ observation }: Props) => {
  const { t } = useTranslation();
  const rows = useExternalReferenceRows(observation);

  if (!rows.length) {
    return null;
  }

  return (
    <ExternalReferenceContainer data-testid="external-reference">
      <ExternalReferenceTitle>
        {t('damage.externalReference', 'External Reference')}
      </ExternalReferenceTitle>
      {rows.map(({ key, label, value }) => (
        <div key={key}>
          <Label>{label}</Label>
          <Description>{value}</Description>
        </div>
      ))}
    </ExternalReferenceContainer>
  );
};
